module.exports = __webpack_public_path__ + "img/speak2.17bab108.png";